module.exports = __webpack_public_path__ + "img/waistline_back_pocket_position.1fb0e126.png";